import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ExhibitorListingItem = ({ exhibitor, onSelect, isSelected }) => {
  const handleClick = () => {
    onSelect(exhibitor);

    // Analytics tracking
    if (typeof gtag === 'function') {
      gtag('event', 'exhibitor_profile_view', {
        exhibitor_name: exhibitor.name,
        exhibitor_id: exhibitor.id,
      });
    }
  };

  const getExhibitorTypeIcon = type => {
    switch (type) {
      case 'Artists':
        return 'fa-paintbrush';
      case 'Authors':
        return 'fa-book';
      case 'Exhibitors':
      default:
        return 'fa-exhibit-booth';
    }
  };

  const formatLocation = location => {
    if (!location || !location.label) return '';

    // Remove duplicate text from locations as specified in requirements
    const parts = location.label.split(',').map(part => part.trim());
    if (parts.length > 1) {
      const firstPart = parts[0];
      const baseName = firstPart.split(':')[0];

      // Remove duplicate base names from subsequent parts
      const uniqueParts = [firstPart];
      for (let i = 1; i < parts.length; i++) {
        if (!parts[i].startsWith(baseName)) {
          uniqueParts.push(parts[i]);
        } else {
          // Extract just the booth/table number
          const match = parts[i].match(/(\d+)/);
          if (match) {
            uniqueParts.push(match[1]);
          }
        }
      }
      return uniqueParts.join(', ');
    }

    return location.label;
  };

  const truncateTags = (tags, maxLength = 3) => {
    if (!tags || tags.length === 0) return [];
    return tags.slice(0, maxLength);
  };

  return (
    <div
      className={classNames('exhibitor-listing-item', { selected: isSelected })}
      onClick={handleClick}
    >
      <div className="exhibitor-header">
        <div className="exhibitor-type-icon">
          <i
            className={`fa ${getExhibitorTypeIcon(exhibitor.exhibitorType)}`}
          ></i>
        </div>
        <div className="exhibitor-name">{exhibitor.name}</div>
      </div>
      
      <div className="exhibitor-details">
        <div className="exhibitor-logo">
          {exhibitor.avatarUrl && (
            <img
              src={exhibitor.avatarUrl}
              alt={`${exhibitor.name} logo`}
              onError={e => {
                e.target.style.display = 'none';
              }}
            />
          )}
        </div>
        
        <div className="exhibitor-info">
          <div className="exhibitor-tags">
            {truncateTags(exhibitor.tags).map((tag, index) => (
              <span key={index} className="tag-capsule">{tag}</span>
            ))}
            {exhibitor.tags && exhibitor.tags.length > 3 && (
              <span className="tag-more">+{exhibitor.tags.length - 3} more</span>
            )}
          </div>
          
          <div className="exhibitor-location">
            {exhibitor.location && (
              <>
                <i className="fa fa-map-marker"></i>
                <span>{formatLocation(exhibitor.location)}</span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExhibitorListingItem;
